import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddTeamMemberData, SendInviteData, User, UsersResponse, UserState } from "./index.types";

export const initialUserState: UserState = {
  isUserLoading: false,
  isInviteLoading: false,
  isAddTeamMemberLoading: false,
  isUserDeleteLoading: false,
  userDeleteSuccess: false,
  addTeamMemberSuccess: false,
  inviteSentSuccess: false,
  usersList: [],
  addTeamMemberError: null,
};

const name = "MyTeams";

export const userSlice = createSlice({
  name,
  initialState: initialUserState,
  reducers: {
    getUsers: (state) => {
      state.isUserLoading = true;
    },
    sendInvite: (state) => {
      state.isInviteLoading = true;
    },
    addTeamMember: (state) => {
      state.isAddTeamMemberLoading = true;
      state.addTeamMemberError = null;
    },
    deleteUser: (state) => {
      state.isUserDeleteLoading = true;
    },
    addTeamMemberSuccess: (state) => {
      state.isAddTeamMemberLoading = false;
      state.addTeamMemberSuccess = true;
    },
    sendInviteSuccess: (state) => {
      state.isInviteLoading = false;
      state.inviteSentSuccess = true;
    },
    getUsersSuccess: (state, action: PayloadAction<UsersResponse>) => {
      state.isUserLoading = false;
      state.usersList = action.payload.results || [];
      state.nextPageUrl = action.payload.next || null;
    },
    deleteUserSuccess: (state) => {
      state.isUserDeleteLoading = false;
      state.userDeleteSuccess = true;
    },
    getUsersFail: (state) => {
      state.isUserLoading = false;
      state.usersList = [];
    },
    sendInviteFail: (state) => {
      state.isInviteLoading = false;
      state.inviteSentSuccess = false;
    },
    deleteUserFail: (state) => {
      state.isUserDeleteLoading = false;
    },
    addTeamMemberFail: (state, action: PayloadAction<{ message?: string; statusCode?: number; statusText?: any }>) => {
      state.isAddTeamMemberLoading = false;
      state.addTeamMemberSuccess = false;
      state.addTeamMemberError = action.payload?.statusText ?? null;
    },
    setUsersList: (state, { payload }: PayloadAction<User[]>) => {
      state.usersList = payload;
    },
    clearUserStatuses: (state) => {
      state.isUserLoading = false;
      state.isUserDeleteLoading = false;
      state.userDeleteSuccess = false;
    },
    softClearAddTeamStatuses: (state) => {
      state.isAddTeamMemberLoading = false;
      state.addTeamMemberSuccess = false;
      state.isInviteLoading = false;
      state.inviteSentSuccess = false;
      state.addTeamMemberError = null;
    },
  },
});

export const { getUsers, setUsersList, clearUserStatuses, addTeamMemberSuccess, softClearAddTeamStatuses } = userSlice.actions;

export default userSlice.reducer;

export const getUsersList = (query: string) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/users/?account_id=${query}`,
  },
  type: "getUsers",
});

export const deleteUserAPI = (query: string | number) => ({
  payload: {
    apiName: name,
    method: "delete",
    url: `/api/users/${query}/`,
  },
  type: "deleteUser",
});

export const addTeamMemberAPI = (body: AddTeamMemberData | FormData) => ({
  payload: {
    apiName: name,
    method: "post",
    data: body,
    url: `/api/users/api_create_team_member/`,
  },
  type: "addTeamMember",
});

export const sendInviteAPI = (body: SendInviteData) => ({
  payload: {
    apiName: name,
    method: "post",
    data: body,
    url: `/api/send-invitation/`,
  },
  type: "sendInvite",
});
